import { oz } from '@weft/utils';

export const PAYMENT_TERMS = Object.freeze({
  Prepayment: 'Prepayment',
  Postpayment: 'Postpayment',
});

export const PaymentTermSchema = oz.nativeEnum(PAYMENT_TERMS).openapi('PaymentTerm');

export type PaymentTerm = oz.infer<typeof PaymentTermSchema>;